React = require 'react'
t = require('views/internal/recup-with-helpers')('org_ads')
track = require 'debug/track'
getExperiment = require 'lib/experiments/simple-test'

class OrganizationMembersAd extends React.Component
  constructor: (props) ->
    super
    @dismissAndTrack = @dismissAndTrack.bind(@)

  dismissAndTrack: ->
    track('Organization View', 'Members Page', 'Dismiss Security Ad')
    @props.dismissAd()

  render: t.renderable ->
    { billingUrl } = @props
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

    if adsLayoutExperimentEnabled
      t.div '.org-ad.org-ad-members.ads-layout-experiment', =>
        t.button '.close-ad', { onClick: @dismissAndTrack }, ->
          t.icon 'close'

        t.div '.org-ad-body', =>
          t.p '.org-ad-title', ->
            t.format 'ads-title-members'
          t.p '.org-ad-text', ->
            t.format 'ads-text-members'
          t.a '.org-ad-learn-more', { href: '/business-class', target: '_blank', onClick: -> track('Organization View', 'Boards Page', 'Learn more') }, ->
            t.format 'ads-learn-more'
          t.a '.button.primary', { href: billingUrl, onClick: -> track('Organization View', 'Members Page', 'Upgrade Button') }, ->
            t.format 'ads-upgrade'
    else
      t.div '.org-ad', =>
        t.div '.close-ad', { onClick: @dismissAndTrack }, ->
          t.icon 'close'
        t.img '.org-upsell-image', { src: require('images/ads/lock.svg') }
        t.div '.org-ad-description', ->
          t.p '.bold', ->
            t.format "need-more-security"
          t.p ->
            t.format "deactivate-former-members"
        t.a '.button.primary.js-lets-do-this', { href: billingUrl, onClick: -> track('Organization View', 'Members Page', 'Lets Do This Button') }, ->
          t.format "lets-do-this"

class OrganizationBoardsAd extends React.Component
  constructor: (props) ->
    super
    @dismissAndTrack = @dismissAndTrack.bind(@)

  dismissAndTrack: ->
    track('Organization View', 'Boards Page', 'Dismiss Collections Ad')
    @props.dismissAd()

  render: t.renderable ->
    { billingUrl } = @props
    adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

    if adsLayoutExperimentEnabled
      t.div '.org-ad.org-ad-boards.ads-layout-experiment', =>
        t.button '.close-ad', { onClick: @dismissAndTrack }, ->
          t.icon 'close'

        t.div '.org-ad-body', =>
          t.img '.org-upsell-image', { src: require('images/collections/business-class-feature-roadmap.png') }
          t.p '.org-ad-title', ->
            t.format 'ads-title-boards'
          t.p '.org-ad-text', ->
            t.format 'ads-text-boards'
          t.a '.org-ad-learn-more', { href: '/business-class', target: '_blank', onClick: -> track('Organization View', 'Boards Page', 'Learn more') }, ->
            t.format 'ads-learn-more'
          t.a '.button.primary', { href: billingUrl, onClick: -> track('Organization View', 'Boards Page', 'Upgrade Button') }, ->
            t.format 'ads-upgrade'
    else
      t.div '.org-ad', =>
        t.div '.close-ad', { onClick: @dismissAndTrack }, ->
          t.icon 'close'
        t.div '.org-ad-description', ->
          t.p '.bold', ->
            t.format 'need-more-control'
        t.img '.org-upsell-image', { src: require('images/collections/business-class-feature-roadmap.png') }
        t.div '.org-ad-description', ->
          t.p ->
            t.format 'manage-with-business-class'
        t.a '.button.primary.js-lets-do-this', { href: billingUrl, onClick: -> track('Organization View', 'Boards Page', 'Lets Do This Button') }, ->
          t.format "lets-do-this"

module.exports = {
  OrganizationMembersAd,
  OrganizationBoardsAd
}



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-ad-component.coffee